/*
 * See the file LICENSE for the full license governing this code.
 */

import * as React from 'react';
import Stack from '@mui/material/Stack';
import PaperOnCenter, {
  EmailInput,
} from '../components/authentication/AuthComponent';
import { useMutation } from 'react-query';
import { networkWithErrorConvert } from '../api';
import { LinkToAnotherAuth, useAuth } from '../components/authentication';
import { Navigate } from 'react-router-dom';

function useResetPassword() {
  const { setUsername } = useAuth();
  return useMutation((event) => {
    const data = new FormData(event.target);
    const email = data.get('username');
    setUsername(email);
    return networkWithErrorConvert({
      method: 'post',
      url: '/v1/user/reset-password',
      data: { email },
    });
  });
}

export default function ResetPassword() {
  return (
    <PaperOnCenter
      Title="Reset password"
      Inputs={<EmailInput />}
      SuccessMessage={<Navigate to="/reset-password/verify-email" />}
      SecondaryAction={
        <Stack spacing={1}>
          <LinkToAnotherAuth authLink="/signin">
            Back to Sign In
          </LinkToAnotherAuth>
          <LinkToAnotherAuth authLink="/signup">
            Don't have an account? Sign Up
          </LinkToAnotherAuth>
        </Stack>
      }
      SubmitButtonTitle="Reset"
      mutation={useResetPassword}
    />
  );
}
